import React from 'react';
import i18next from 'i18next';
import en from './i18n/en';
import jp from './i18n/jp';

i18next.addResourceBundle('en', 'profilePage', en);
i18next.addResourceBundle('jp', 'profilePage', jp);

const ProfilePageConfig = {
	settings: {
		layout: {}
	},
	routes: [
		{
			path: '/profile',
			exact:true,
			component: React.lazy(() => import('./ProfilePage'))
		}
	]
};

export default ProfilePageConfig;
